"use strict";

function historyTranslationKey(k) {
  return 'publication.activity.history.' + k;
}

function CompanyPublicationActivityTranslator($translate) {
  var translate = function(k) {
    return $translate.instant(k);
  };

  var types = {
    COMMENT: function(c) {
      return {
        text: c.text,
        id: c.id,
        createdAt: c.createdAt,
        type:      "comment",
        user:      c.createdBy,
        commentChild: c.commentChild,
        pageSize: 10
      };
    },
    AUDITLOG: function(a) {
      switch (a.action) {
        case 'UPDATE':
          if (a.extra.newData) {
            if (a.extra.newData.Features) {
              delete a.extra.newData.Features;
            }
            var objectKey = Object.keys(a.extra.newData).length > 1 ? Object.keys(a.extra.newData)[Object.keys(a.extra.newData).length - 1] : Object.keys(a.extra.newData)[0];
            var textMore = (a.extra.newData.Status ? (' to ' + $translate.instant('publication.' + angular.lowercase(a.extra.newData.Status))) : '') + (a.extra.newData.Priority ? (' to ' + a.extra.newData.Priority.name) : '') + (a.extra.newData.Reference ? (' to ' + a.extra.newData.Reference) : '');
            if(a.extra.newData.Tags){
              textMore = ': ';
              angular.forEach(a.extra.newData.Tags, function(value, key){
                if(key>0){
                  textMore += ', ' + value;
                }else{
                  textMore += value;
                }
              });
            }
            if(a.extra.newData.Category){
              textMore = " " + $translate.instant("to").toLowerCase() + " " + a.extra.newData.Category.name;
            }
            if (objectKey === 'Parent') {
              return {
                text: a.extra.newData.Parent ? $translate.instant("publication.activity.history.updated") + ": " + $translate.instant('publication.activity.history.set-parent', {
                  user:    a.performedBy.name
                }) : $translate.instant("publication.activity.history.updated") + ": " + $translate.instant('publication.activity.history.unset-parent', {
                  user:    a.performedBy.name
                }) + textMore,
                createdAt:  a.performedAt,
                type:       "history",
                user:       a.performedBy
              };
            } else {
              if(objectKey){
                console.log(textMore);
                return {
                  text: $translate.instant("publication.activity.history.updated") + ": " +
                         [objectKey]
                           .map(historyTranslationKey)
                           .map(translate)
                           .join(", ") + textMore,
                  createdAt: a.performedAt,
                  user:      a.performedBy,
                  type:      "history"
                };
              }
            }
          } 
          if(a.extra.data && a.extra.data.step){
            return {
              text: $translate.instant("publication.activity.history.updated") + " " + $translate.instant("step") + " " + a.extra.data.step,
              createdAt: a.performedAt,
              user:      a.performedBy,
              type:      "history"
            };
          }
          if(a.extra.inforName){
            return {
              text: $translate.instant("notification.actions.updated") + ": keypass " + $translate.instant("notification.named") + " " + a.extra.inforName,
              createdAt: a.performedAt,
              user:      a.performedBy,
              type:      "history"
            };
          }
          break;  
        case 'CREATE':
          if(a.extra.inforName){
            return {
              text: $translate.instant("notification.actions.created") + ": keypass " + $translate.instant("notification.named") + " " + a.extra.inforName,
              createdAt: a.performedAt,
              user:      a.performedBy,
              type:      "history"
            };
          }else{
            if(a.extra.objectType === 'CHECKLIST'){
              if(a.extra.isItem){
                return {
                  text: $translate.instant("publication.activity.history." + a.action + "-item", {
                    user:     a.performedBy.name,
                    checkItem: a.extra.checkItem,
                    checklist: a.extra.object.name
                  }),
                  createdAt: a.performedAt,
                  user:      a.performedBy,
                  type:      "history"
                };
              }else{
                return {
                  text: $translate.instant("publication.activity.history." + a.action + "-checklist", {
                    user:     a.performedBy.name,
                    checkItem: a.extra.checkItem,
                    checklist: a.extra.object.name
                  }),
                  createdAt: a.performedAt,
                  user:      a.performedBy,
                  type:      "history"
                };
              }
            }else{
              return {
                text: $translate.instant("notification.actions.object." + a.action),
                createdAt: a.performedAt,
                user:      a.performedBy,
                type:      "history"
              };
            }
          }
          break;
        case 'DELETE':
          if(a.extra.inforName){
            return {
              text: $translate.instant("notification.actions.deleted") + ": keypass " + a.extra.inforName,
              createdAt: a.performedAt,
              user:      a.performedBy,
              type:      "history"
            };
          }else{
            if(a.extra.objectType === 'CHECKLIST'){
              if(a.extra.isItem){
                return {
                  text: $translate.instant("publication.activity.history." + a.action + "-item", {
                    user:     a.performedBy.name,
                    checkItem: a.extra.checkItem,
                    checklist: a.extra.object.name
                  }),
                  createdAt: a.performedAt,
                  user:      a.performedBy,
                  type:      "history"
                };
              }else{
                return {
                  text: $translate.instant("publication.activity.history." + a.action + "-checklist", {
                    user:     a.performedBy.name,
                    checkItem: a.extra.checkItem,
                    checklist: a.extra.object.name
                  }),
                  createdAt: a.performedAt,
                  user:      a.performedBy,
                  type:      "history"
                };
              }
            }
          }
          break;
        case 'FILE_UPLOADED':
          return {
            text:       $translate.instant('publication.activity.uploaded', {
              user:     a.performedBy.name,
              filename: a.extra.fileName
            }),
            createdAt:  a.performedAt,
            type:       "upload",
            user:       a.performedBy
          };
        case 'FILE_VIEW':
          return {
            text:       $translate.instant('publication.activity.viewed', {
              user:     a.performedBy.name,
              filename: a.extra.fileName
            }),
            createdAt:  a.performedAt,
            type:       "upload",
            user:       a.performedBy
          };
        case 'FILE_DOWNLOADED':
          return {
            text:       $translate.instant('publication.activity.history.downloaded-file'),
            createdAt:  a.performedAt,
            type:       "upload",
            user:       a.performedBy
          };
        case 'ADDED_WATCHER':
          return {
            text:       $translate.instant('publication.activity.history.add-watcher', {
              user:     a.performedBy.name,
              watcher: a.extra.watcher.name
            }),
            createdAt:  a.performedAt,
            type:       "history",
            user:       a.performedBy
          };
        case 'REMOVED_WATCHER':
          return {
            text:       $translate.instant('publication.activity.history.remove-watcher', {
              user:     a.performedBy.name,
              watcher: a.extra.watcher.name
            }),
            createdAt:  a.performedAt,
            type:       "history",
            user:       a.performedBy
          };
        case 'CHECK':
          return {
            text:       $translate.instant('publication.activity.history.check', {
              user:     a.performedBy.name,
              checkItem: a.extra.checkItem,
              checklist: a.extra.object.name
            }),
            createdAt:  a.performedAt,
            type:       "history",
            user:       a.performedBy
          };
        case 'UNCHECK':
          return {
            text:       $translate.instant('publication.activity.history.uncheck', {
              user:     a.performedBy.name,
              checkItem: a.extra.checkItem,
              checklist: a.extra.object.name
            }),
            createdAt:  a.performedAt,
            type:       "history",
            user:       a.performedBy
          };
        case 'DONE':
          return {
            text:       $translate.instant('publication.activity.history.done', {
              user:     a.performedBy.name,
              checklist: a.extra.object.name
            }),
            createdAt:  a.performedAt,
            type:       "history",
            user:       a.performedBy
          };
        case 'FILE_INVISIBLE':
          return {
            text:       $translate.instant('publication.activity.history.invisible', {
              user:     a.performedBy.name,
              filename: a.extra.fileName
            }),
            createdAt:  a.performedAt,
            type:       "history",
            user:       a.performedBy
          };
        case 'FILE_VISIBLE':
          return {
            text:       $translate.instant('publication.activity.history.visible', {
              user:     a.performedBy.name,
              filename: a.extra.fileName
            }),
            createdAt:  a.performedAt,
            type:       "history",
            user:       a.performedBy
          };
        case 'SHARED':
          if (a.extra.action === 'END_SHARE') {
            return {
              text:      $translate.instant('publication.activity.end-shared', {
                user:    a.performedBy.name
              }),
              createdAt:  a.performedAt,
              type:       "shares",
              user:       a.performedBy
            };
          }
          return {
            text:      $translate.instant('publication.activity.shared', {
              user:    a.performedBy.name,
              email:   a.extra.email
            }),
            createdAt:  a.performedAt,
            type:       "shares",
            user:       a.performedBy
          };
        case 'FORM_SUBMIT':
          return {
            text:      $translate.instant('publication.activity.history.form-submit'),
            createdAt:  a.performedAt,
            type:       "history",
            user:       null
          };   
        case 'VERIFY':
          return {
            text: $translate.instant('publication.activity.history.verified'),
            createdAt: a.performedAt,
            user:      a.performedBy,
            type:      "history"
          };      
        case 'CREATED_E_SIGN':
          return {
            text: $translate.instant('publication.activity.history.created-esign', {
              user:    a.performedBy.name,
              emails:  a.extra.emails
            }),
            createdAt: a.performedAt,
            user:      a.performedBy,
            type:      "history"
          };       
        case 'SIGNED':
          return {
            text: $translate.instant('publication.activity.history.signed', {
              user:    a.extra.email,
              ip:      a.extra.ip
            }),
            createdAt: a.performedAt,
            user:      {email: a.extra.email},
            type:      "history"
          };         
        case 'ALL_SIGNED':
          return {
            text: $translate.instant('publication.activity.history.all-signed'),
            createdAt: a.performedAt,
            user:      {name: 'A L L'},
            type:      "history"
          };       
        case 'VISIT_E_SIGN':
          return {
            text: $translate.instant('publication.activity.history.visit-esign', {
              user:    a.extra.email,
              ip:      a.extra.ip
            }),
            createdAt: a.performedAt,
            user:      {email: a.extra.email},
            type:      "history"
          };      
        case 'SEND_EMAIL':
          return {
            text: $translate.instant('publication.activity.history.send-email', {
              email:    a.extra.to
            }),
            createdAt: a.performedAt,
            user:      {email: a.extra.to},
            type:      "history"
          };  
      }
    }
  };
  
  return function(item) {
    if(types.hasOwnProperty(item.activityType)) {
      return types[item.activityType](item);
    }
    
    return false;
  };
}

angular.module("dokiv")
  .factory("CompanyPublicationActivityTranslator", ["$translate", CompanyPublicationActivityTranslator]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationActivityTranslator.js
// module id = 42
// module chunks = 0